// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********* PRIMARY ***********/
/********* DARK ***********/
/********* LIGHT ***********/
/********* ACCENT ALTERNATES ***********/
/********* STATUS ***********/
container__header {
  height: 10.5rem;
  padding: 10px 0 10px 20px;
}
container__header .header__controls--wrapper li {
  margin-right: 20px;
}

.account_menu ul ul {
  display: none;
}

.account_menu ul li:hover > ul {
  display: block;
}

.account_menu ul {
  list-style: none;
  position: relative;
  justify-content: end;
}

.account_menu > ul > li {
  flex: 0 1 auto;
  margin-right: 20px;
}

.account_menu > ul ul {
  background: white;
  border-radius: 0px;
  position: absolute;
  top: 28px;
  right: 22px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
}

.account_menu ul ul li {
  color: rgb(34, 34, 34);
  font-size: 14px;
  padding: 15px 40px;
  cursor: pointer;
}

.account_menu ul ul li:hover {
  background: rgb(61, 61, 184);
  padding: 15px 40px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.account_menu ul ul li:nth-child(2):hover {
  color: rgb(255, 255, 255);
}

.account_menu ul ul:before {
  content: "";
  border: 10px solid transparent;
  border-bottom-color: rgb(255, 255, 255);
  position: absolute;
  right: 0;
  top: -20px;
}

.account_menu ul ul li:first-child:hover {
  background: transparent;
  cursor: default;
}

.menu-link {
  cursor: pointer;
  text-decoration: none;
  color: rgb(255, 255, 255);
}

.user-details {
  display: flex;
  flex-direction: column;
  width: 190px;
}

.menu-dropdown {
  background-color: rgb(255, 255, 255) !important;
  z-index: 100;
}
.menu-dropdown li {
  text-align: center;
}
.menu-dropdown li:nth-child(2) {
  border-top: 1px solid rgba(0, 0, 0, 0.5098039216);
}

.icon-color-white {
  color: rgb(255, 255, 255);
}

.header-bg-blue {
  background-color: #66c;
}

.header__logo img {
  width: 235px;
  height: 45px;
}

li {
  cursor: pointer;
}

.icon-onHover {
  position: relative;
}

.hover-text {
  display: none;
  position: absolute;
  top: 100%;
  right: 10px;
  background-color: rgb(255, 255, 255);
  color: rgb(0, 0, 0);
  padding: 10px;
  border-radius: 4px;
  border: 1px solid rgb(179, 178, 177);
  width: 600px;
  z-index: 1000;
}

.icon-onHover:hover .hover-text {
  display: block;
}`, "",{"version":3,"sources":["webpack://./node_modules/@collab/comp-library/style/settings/_color.scss","webpack://./src/app/shared/components/header/header.component.scss"],"names":[],"mappings":"AAeA,8BAAA;AAMA,2BAAA;AAMA,4BAAA;AAMA,wCAAA;AAMA,6BAAA;ACrCA;EACE,eAAA;EACA,yBAAA;AAIF;AADI;EACE,kBAAA;AAGN;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,oBAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mDAAA;AACF;;AAEA;EACE,sBDnCO;ECoCP,eAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,4BDjCe;ECkCf,kBAAA;EACA,8BAAA;EACA,+BAAA;AACF;;AAEA;EACE,yBD5CM;AC6CR;;AAEA;EACE,WAAA;EACA,8BAAA;EACA,uCDlDM;ECmDN,kBAAA;EACA,QAAA;EACA,UAAA;AACF;;AAEA;EACE,uBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,qBAAA;EACA,yBDhEM;ACiER;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,+CAAA;EACA,YAAA;AACF;AACE;EACE,kBAAA;AACJ;AAEE;EACE,iDAAA;AAAJ;;AAKA;EACE,yBDxFM;ACsFR;;AAKA;EACE,sBAAA;AAFF;;AAKA;EACE,YAAA;EACA,YAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,oCDjHM;ECkHN,mBDjHM;ECkHN,aAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;AAFF;;AAKA;EACE,cAAA;AAFF","sourcesContent":["$gray-dark: rgb(232, 232, 232);\r\n\r\n// Missing from old color.scss\r\n$accordion-border: $gray-dark;\r\n\r\n// Adding new color family\r\n\r\n$gray-1: rgb(34, 34, 34);\r\n$gray-2: rgb(119, 119, 122);\r\n$gray-3: rgb(153, 153, 154);\r\n$gray-4: rgb(179, 178, 177);\r\n\r\n$white: rgb(255, 255, 255);\r\n$black: rgb(0, 0, 0);\r\n\r\n/********* PRIMARY ***********/\r\n$accent-primary: rgba(61, 61, 184, 1);\r\n$accent-primary-alt:rgba(46, 46, 138, 1);\r\n$secondary: rgb(38, 202, 211);\r\n$secondary-1: rgb(0, 153, 168);\r\n\r\n/********* DARK ***********/\r\n$dark-1: $black;\r\n$dark-2: rgb(17, 24, 39);\r\n$dark-3: rgb(119, 119, 122);\r\n$dark-4: rgb(203, 203, 203);\r\n\r\n/********* LIGHT ***********/\r\n$light-1: $white;\r\n$light-2: rgb(244, 244, 244);\r\n$light-3: rgb(245, 245, 251);\r\n$light-4: rgb(238, 238, 240);\r\n\r\n/********* ACCENT ALTERNATES ***********/\r\n$alternate-Accent-1: rgba(102, 102, 204, 1);\r\n$alternate-Accent-2: rgb(0, 147, 201);\r\n$alternate-Accent-3: rgb(0, 155, 222);\r\n$alternate-Accent-4: rgb(238, 244, 250);\r\n\r\n/********* STATUS ***********/\r\n$error: rgb(142, 0, 0);\r\n$error-alt: rgb(221, 34, 37);\r\n$warning: rgb(122, 89, 0);\r\n$success: rgb(0, 116, 0);\r\n\r\n// Assigning color to element\r\n$body-bg: $white;\r\n$main-content-bg: $light-3;\r\n$error: $error;\r\n$success: $success;\r\n$warning: $warning;\r\n\r\n// Navigation\r\n$nav-bg: $white;\r\n$nav-text-inactive: $accent-primary;\r\n$nav-text-active: $accent-primary;\r\n$nav-link-active-bg: rgba($accent-primary, 0.15);\r\n$nav-link-active-highlight: $accent-primary;\r\n$nav-right-border: $dark-4;\r\n\r\n// Button\r\n$button-primary-text: $white;\r\n$button-primary-background: $accent-primary;\r\n$button-primary-hover-background: $alternate-Accent-1;\r\n$button-primary-active-background: $accent-primary-alt;\r\n$button-primary-disabled-background: $dark-4;\r\n$button-primary-disabled-text: $white;\r\n$button-primary-disabled-icon: $white;\r\n\r\n$button-secondary-text: $dark-2;\r\n$button-secondary-background: $white;\r\n$button-secondary-border: $accent-primary;\r\n$button-secondary-hover-textColor: $alternate-Accent-1;\r\n$button-secondary-active-textColor: $accent-primary;\r\n$button-secondary-active-border: $accent-primary;\r\n$button-secondary-disabled-background: $white;\r\n$button-secondary-disabled-text: $dark-4;\r\n$button-secondary-disabled-icon: $dark-4;\r\n$button-secondary-disabled-border: $dark-4;\r\n\r\n$button-error-text: $white;\r\n$button-error-background: $error;\r\n$button-error-hover-background: $error-alt;\r\n\r\n$button-error-active-textColor: $accent-primary;\r\n$button-error-active-border: $accent-primary;\r\n\r\n$text-link-text: $accent-primary;\r\n$button-link-disabled-text: $dark-4;\r\n$button-link-disabled-icon: $dark-4;\r\n\r\n\r\n$button-icon-outline-disabled-background: $white;\r\n$button-icon-outline-disabled-icon: $white;\r\n$button-icon-outline-disabled-border: $dark-4;\r\n$button-icon-nooutline-disabled-icon: $dark-4;\r\n\r\n\r\n$button-add-disabled-background: $dark-4;\r\n$button-add-disabled-text: $white;\r\n$button-add-disabled-icon: $white;\r\n\r\n\r\n// Tabs\r\n$tab-text-regular: $dark-2;\r\n$tab-text-selected: $accent-primary;\r\n$tab-underline-regular: $dark-4;\r\n$tab-underline-selected: $accent-primary;\r\n$tab-underline-divider: $dark-4;\r\n\r\n\r\n// Formfields\r\n$border-color-textbox: $dark-4;\r\n$border-color-select: $dark-4;\r\n$border-color-textarea: $dark-4;\r\n$border-color-toggleswitch: transparent;\r\n$background-color-textbox: $white;\r\n$background-color-select: $white;\r\n$background-color-textarea: $white;\r\n$background-color-toggleswitch-off: $dark-4;\r\n$background-color-toggleswitch-on: $accent-primary;\r\n$background-color-toggleswitch-knob: $white;\r\n$font-color-textbox: inherit;\r\n$font-color-select: inherit;\r\n$font-color-textarea: inherit;\r\n$formfield-focus: $accent-primary;\r\n$disabled-font-color: $dark-4;\r\n$disabled-background-color: $light-4;\r\n$input-focus-color: $secondary;\r\n\r\n\r\n// Breadcrumb\r\n$breadcrumb-active: $accent-primary;\r\n$breadcrumb-hover:$accent-primary-alt;\r\n$breadcrumb-current: $dark-2;\r\n\r\n\r\n//Button\r\n\r\n\r\n//error-banner\r\n$error-banner-border:$error;\r\n$error-banner-background:$light-4;\r\n$error-banner-focus:$dark-3;\r\n\r\n\r\n\r\n","@import \"@collab/comp-library/style/settings/color\";\n@import \"@collab/comp-library/style/mixins/common\";\ncontainer__header {\n  height: 10.5rem;\n  padding: 10px 0 10px 20px;\n\n  .header__controls--wrapper {\n    li {\n      margin-right: 20px;\n    }\n  }\n}\n\n.account_menu ul ul {\n  display: none;\n}\n\n.account_menu ul li:hover>ul {\n  display: block;\n}\n\n.account_menu ul {\n  list-style: none;\n  position: relative;\n  justify-content: end;\n}\n\n.account_menu>ul>li {\n  flex: 0 1 auto;\n  margin-right: 20px;\n}\n\n.account_menu>ul ul {\n  background: #ffff;\n  border-radius: 0px;\n  position: absolute;\n  top: 28px;\n  right: 22px;\n  box-shadow: 0px 3px 6px #00000029;\n}\n\n.account_menu ul ul li {\n  color: $gray-1;\n  font-size: 14px;\n  padding: 15px 40px;\n  cursor: pointer;\n}\n\n.account_menu ul ul li:hover {\n  background: $accent-primary;\n  padding: 15px 40px;\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n\n.account_menu ul ul li:nth-child(2):hover {\n  color: $white;\n}\n\n.account_menu ul ul:before {\n  content: \"\";\n  border: 10px solid transparent;\n  border-bottom-color: $white;\n  position: absolute;\n  right: 0;\n  top: -20px;\n}\n\n.account_menu ul ul li:first-child:hover {\n  background: transparent;\n  cursor: default;\n}\n\n.menu-link {\n  cursor: pointer;\n  text-decoration: none;\n  color: $white;\n}\n\n.user-details {\n  display: flex;\n  flex-direction: column;\n  width: 190px;\n}\n\n.menu-dropdown {\n  background-color: $light-1 !important;\n  z-index: 100;\n\n  li {\n    text-align: center;\n  }\n\n  li:nth-child(2) {\n    border-top: 1px solid #00000082;\n  }\n}\n\n\n.icon-color-white {\n  color: $white;\n}\n\n.header-bg-blue {\n  background-color: #66c;\n}\n\n.header__logo img {\n  width: 235px;\n  height: 45px;\n}\n\nli {\n  cursor: pointer;\n}\n\n.icon-onHover {\n  position: relative;\n}\n\n.hover-text {\n  display: none;\n  position: absolute;\n  top: 100%;\n  right: 10px;\n  background-color: $white;\n  color: $black;\n  padding: 10px;\n  border-radius: 4px;\n  border: 1px solid $gray-4;\n  width: 600px;\n  z-index: 1000;\n}\n\n.icon-onHover:hover .hover-text {\n  display: block; \n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
